import { Badge, IconButton } from '@mui/material';
import { ReactComponent as EditIcon } from '../../../assets/images/edit.svg';
import moment from 'moment';
import { MRT_ColumnDef } from 'material-react-table';
import { UpcomingServiceInterface } from '../../../utils/types/upcomingService';
import { fixUTCDateForInput } from '../../../utils/lib';

type Operator = {
  id: string;
  name: string;
  lastName: string;
};

const getUpcomingServiceGridColumns = (
  onEditUpcomingService: (upcomingService: UpcomingServiceInterface) => void
): Array<MRT_ColumnDef<UpcomingServiceInterface>> => [
  {
    accessorKey: 'service_date',
    header: 'Service date',
    size: 100,
    Cell: ({ cell }) => {
      if (!cell) {
        return '--';
      } else {
        const value = cell.getValue<string>();
        return (
          <span style={{ color: '#52659B', fontWeight: 500 }}>{fixUTCDateForInput(value)}</span>
        );
      }
    }
  },
  {
    accessorKey: 'state',
    header: 'State',
    enableSorting: true,
    size: 100,
    Cell: ({ cell }) => {
      const value = cell.getValue<string>();
      const stateHexaMap: { [key: string]: string } = {
        green: '#4CAF50',
        yellow: '#FFC107',
        red: '#F44336'
      };

      return (
        <Badge
          color="primary"
          badgeContent={''}
          sx={{
            '.MuiBadge-badge': {
              backgroundColor: stateHexaMap[value],
              position: 'relative',
              top: 0,
              left: 0
            }
          }}
        />
      );
    }
  },
  {
    accessorKey: 'title',
    header: 'Title',
    enableSorting: true
  },
  {
    accessorKey: 'additional_information',
    header: 'Additional Information',
    Cell: ({ cell }) => {
      const value = cell.getValue<string>();
      return <span style={{ color: '#52659B', fontWeight: 500 }}>{value}</span>;
    }
  },
  {
    accessorKey: 'creator',
    header: 'Created By',
    Cell: ({ cell }) => {
      const value = cell.getValue<Operator>();
      if (value) {
        return `${value.name} ${value.lastName}`;
      } else {
        return '--';
      }
    }
  },
  {
    accessorKey: 'createdAt',
    header: 'Created at',
    Cell: ({ cell }) => {
      const value = cell.getValue<string>();
      return <span style={{ color: '#52659B', fontWeight: 500 }}>{moment(value).fromNow()}</span>;
    }
  },
  {
    accessorKey: 'actions',
    header: 'Actions',
    enableSorting: false,
    Cell: ({ cell }: any) => (
      <>
        <IconButton
          color="secondary"
          aria-label="Edit"
          onClick={() => onEditUpcomingService(cell.row.original)}>
          <EditIcon />
        </IconButton>
      </>
    )
  }
];

export default getUpcomingServiceGridColumns;
